export class ErrorWithCode extends Error {
  constructor(message, code, ...args) {
    super(message, ...args)
    this.code = code
  }
}
